export enum ShibaState {
    ON_TREE,
    FLYING_AWAY,
    ON_MOUNTAIN,
    GOING_TO_FIRE,
    KILLING_FIRE,
    FIRE_KILLED
}
